import axios from "axios";
import { refreshToken } from "../service/RefreshTokenService";
import { getEnv } from "./EnvHelper";
import { resolveBackendForHost } from "./DomainConfigHelper";


const host = window.location.hostname.toLowerCase();

const axiosInterceptor = axios.create({
    baseURL: getEnv("REACT_APP_HYBRID_MODE") == "true"
        ? window.location.origin + "/"
        : resolveBackendForHost(host).backendUrl ||
              getEnv("REACT_APP_BACKEND_BASE_URL"),
    // headers: {
    //     "Content-Type": "application/json",
    // },
    withCredentials: true,
})

// Add an interceptor to attach the machine ID to every request
axiosInterceptor.interceptors.request.use(config => {
    const machineId = localStorage.getItem("md");
    if (machineId) {
        config.headers["X-machineId"] = machineId;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

axiosInterceptor.interceptors.response.use((response) => {
    return response;
}, async function (error) {
    const originalRequest = error.config;
    const isSessionProbe = originalRequest?.url?.includes('jwtServices/load-by-username');
    if (error?.response?.status === 403 && !originalRequest?._retry && !isSessionProbe) {
        originalRequest._retry = true;
        const refreshTokenResponse = await refreshToken();
        if (refreshTokenResponse?.status === 200) {
            return axiosInterceptor(originalRequest);
        }
    }
    return Promise.reject(error);
})

export default axiosInterceptor;